import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { GSPMetadataService } from '../metadata.service';

// mock数据
const classifier: any[] = [
  { id: 'project', text: '工程内元数据' },  // 0
  { id: 'local', text: '离线的元数据' },    // 1
  { id: 'remote', text: '仓库中元数据' },   // 2
  { id: 'ref', text: '引用的元数据' }       // 3
];

const classifierForBo: any[] = [
  { id: 'bo', text: 'BO内元数据' },  // 0
  { id: 'local', text: '离线的元数据' },    // 1
  { id: 'remote', text: '仓库中元数据' },   // 2
  { id: 'ref', text: '引用的元数据' } ,       // 3
  { id: 'db', text: '数据库中元数据' }       // 4
];

@Injectable()
export class MetadataService {
  currentProjectPath: string;
  rootPath: string;
  packRefPath: string;
  selectedChange = new EventEmitter<string>();
  constructor(private gspMetadataService: GSPMetadataService) {
    this.packRefPath = '/packages';
  }
  // mock树节点数据
  treeData: any[];
  getMetadataClassifier(type) {
    switch (type) {
      case 'bo':
        const classifiers: any[] = [];
        this.gspMetadataService.GetClassifier().subscribe(items => {
          if (items && items.length > 0) {
            items.forEach(item => {
              const itemT = {
                id: item.id,
                text: item.text
              };
              classifiers.push(itemT);
            });
          }
        });
        return classifiers;
      case 'project':
      default:
        return classifier;
    }
  }
  // tslint:disable-next-line:member-ordering
  metadatas = [];
  addMetadata(metadata) {
    this.metadatas.push(metadata);
  }
  clearMetadata() {
    this.metadatas = [];
  }
  // tslint:disable-next-line:member-ordering
  packages = [];
  addPackage(mp) {
    this.packages.push(mp);
  }
  clearPackage() {
    this.packages = [];
  }

  // 获取当前工程下所有的元数据
  GetMetadataList(typeName: string): Observable<any> {
    return this.gspMetadataService.GetMetadataList(this.currentProjectPath, typeName);
  }

  // 获取当前工程下所有的元数据
  GetMetadataListInBo(typeName: string): Observable<any> {
    return this.gspMetadataService.GetMetadataListInBo(this.currentProjectPath, typeName);
  }

  GetMetadataByFilter(typeCode: string, postfix: string, filter: string): Observable<any> {
    return this.gspMetadataService.GetMetadataByFilter(this.currentProjectPath, typeCode, filter, postfix);
  }

  // 获取元数据工程信息（获取本工程依赖的元数据包基本信息）
  GetMetadataProjectInfo(): Observable<any> {
    return this.gspMetadataService.GetProjectInfo(this.currentProjectPath);
  }

  // 获取工程路径
  GetMetadataProjPath(metadataPath: string): Observable<any> {
    return this.gspMetadataService.GetProjectInfo(metadataPath);
  }

  // tslint:disable-next-line:max-line-length
  GetMetadataInfos(scope, codelanguage: string, isMavenEnable: boolean, metadataType = null, searchText = null, page = null, selectedPackageSource = null) {
    if (codelanguage === 'dotnet' || isMavenEnable === false) {
      return this.gspMetadataService.GetMetadataInfosByScope(scope, metadataType, searchText, page,
        selectedPackageSource, this.currentProjectPath);
    } else {
      return this.gspMetadataService.GetMetadataInfosByScope4Java(scope, metadataType, searchText, page,
        selectedPackageSource, this.currentProjectPath);
    }
  }

  // 获取元数据包中所包含的元数据信息
  GetMetadataPackageInfo(packPath: string, packageName: string): Observable<any> {
    let fullName = '';
    if (packageName.endsWith('mdpkg')) {
      fullName = packageName;
    } else {
      fullName = packageName + '.mdpkg';
    }
    return this.gspMetadataService.GetMetadataPackageInfo(packPath, fullName);
  }
  pickMetadataIndex(scope: number, metadataIndexDto: any, codelanguage: string, isMavenEnable: boolean): Observable<any> {
    // if (codelanguage === 'dotnet' || isMavenEnable === false) {
    //   scope = scope === 3 ? 2 : scope;
    //   return this.gspMetadataService.pickMetadataIndex(scope, this.currentProjectPath, metadataIndexDto);
    // } else {
      return this.gspMetadataService.pickMetadataIndex(scope, this.currentProjectPath, metadataIndexDto);
    // }
  }
  // Load元数据
  LoadTheMetadata(metadata: any): Observable<any> {
    if (metadata) {
      const fileName = metadata.fileName;
      const relativePath = metadata.relativePath;
      return this.gspMetadataService.LoadMetadataInBo(fileName, relativePath, this.currentProjectPath);
    }
    return new Observable<any>();
  }

  // Load元数据
  LoadMetadata(): Observable<any> {
    if (this.metadatas.length > 0) {
      const index1 = this.metadatas.length;
      if (index1 > 0) {
        const index2 = this.metadatas[index1 - 1].treenode.MetadataInfo.length;
        if (index2 > 0) {
          const fileName = this.metadatas[index1 - 1].treenode.MetadataInfo[index2 - 1].FileName;
          const relativePath = this.metadatas[index1 - 1].treenode.MetadataInfo[index2 - 1].RelativePath;
          return this.gspMetadataService.LoadMetadata(fileName, relativePath);
        }
      } else {
        return new Observable<any>();
      }
    }
  }

  // // 获取元数据以及包的信息
  // GetTheMetadataFromPackage(metadata): Observable<any> {
  //   if (metadata) {
  //     const packageName = metadata.mdPkgName;
  //     const metadataID = metadata.id;
  //     return this.gspMetadataService.GetMetadataFromPackage(packageName, null, metadataID);
  //   }
  //   return new Observable<any>();
  // }

  // // 获取元数据以及包的信息
  // GetMetadataFromPackage(): Observable<any> {
  //   const index1 = this.metadatas.length;
  //   if (index1 > 0) {
  //     const index2 = this.metadatas[index1 - 1].treenode.MetadataInfo.length;
  //     if (index2 > 0) {
  //       const packageName = this.metadatas[index1 - 1].treenode.PackageName;
  //       const packagePath = this.metadatas[index1 - 1].treenode.Location;
  //       const metadataID = this.metadatas[index1 - 1].treenode.MetadataInfo[index2 - 1].ID;
  //       return this.gspMetadataService.GetMetadataFromPackage(packageName, packagePath, metadataID);
  //     }
  //   } else {
  //     return new Observable<any>();
  //   }
  // }

  // 获取某个路径下的所有元数据包
  GetMetadataPackages(): Observable<any> {
    return this.gspMetadataService.GetMetadataPackages('packages');
  }

  // 更新工程引用
  UpdateMetadataProject(packageHeader: any): Observable<any> {
    // this.gspMetadataService.UpdateMetadataProject(this.currentProjectPath, packageHeader).then(response => {
    //   if (response.status === 200) {
    //     this.treeData = [];
    //     this.Refresh();
    //   }
    // });
    return this.gspMetadataService.UpdateMetadataProject(this.currentProjectPath, packageHeader);
  }

  public getCodeLanguage(): Observable<any> {
    return this.gspMetadataService.getCodeLanguage(this.currentProjectPath);
  }

  public getProcessMode(): Observable<any> {
    return this.gspMetadataService.getProcessMode(this.currentProjectPath);
  }

  Refresh() {
    this.treeData = this.getMetadataClassifier('');
    this.treeData[1].items = [];
    let packages = [];

    this.GetMetadataProjPath(this.currentProjectPath).subscribe(proj => {
      this.currentProjectPath = proj.projectPath;
      this.GetMetadataProjectInfo().subscribe(meta => {
        packages = meta.nugetPackageRefs;
        let index = 0;
        packages.forEach(item => {
          const child = {
            id: item.name,
            text: item.name,
            items: []
          };
          if (this.treeData) {
            this.treeData[1].items.push(child);
          }
          this.gspMetadataService.GetDevRootPath().subscribe(root => {
            const rootPath = root + this.packRefPath;
            this.gspMetadataService.GetMetadataPackagesUnderNugetDir(rootPath + '/' + item.name).subscribe(pkgs => {
              if (pkgs) {
                let mdpkg;
                pkgs.forEach(pkg => {
                  mdpkg = {
                    id: pkg.header.name,
                    text: pkg.header.name,
                    desc: pkg.header.location
                  };
                  child.items.push(mdpkg);
                });
                // this.files[1].items[index].push(mdpkg);
              }
              index = index + 1;
            });
          });
        });
      });
    });
  }

  public getBoPath(): Observable<any> {
    return this.gspMetadataService.getBoPath(this.currentProjectPath);
  }
}
